<template>
  <div class="forum-detail-modular">
    <div class="header-menu-bar-modular">
      <div class="menu-bar">
        <div
          class="menu-bar-item"
          v-for="(item, index) in menuBar"
          :key="index"
        >
          <span class="top-bar-title" @click="toPersonCenter(index)">{{
            currLanguage == 3 ? item.eng_title : item.title
          }}</span>
          <img
            class="top-bar-icon"
            v-if="index < menuBar.length - 1"
            src="../assets/productDetail/top-bar-icon.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="forum-detail-body">
      <div class="forum-detail-body-modular">
        <div class="forum-detail-landlord-modualr">
          <!-- <el-row style="background-color: #FBFBFD;">
            <el-col :span="4" :xs="24"> -->
          <div class="left-item-modualr">
            <img
              class="user-face"
              :src="discussList.landlord.head_img"
              alt=""
            />
            <div class="user-name">{{ discussList.landlord.write }}</div>
          </div>
          <!-- </el-col>
            <el-col :span="20" :xs="24" style="background-color: #FFFFFF;"> -->
          <div class="right-item-modualr">
            <div class="problem-title">{{ discussList.landlord.title }}</div>
            <div class="detail-nfo-modular">
              <div class="left-item">
                <div class="from-type">
                  {{ $t("translateText.fromtopicText")
                  }}<span class="from-type-title">{{ menuBar[2].title }}</span>
                </div>
              </div>
              <div class="right-item">
                <div class="new-item">
                  <img
                    class="news-icon"
                    src="../assets/forum/news-icon.png"
                    alt=""
                  />
                  <span>
                    {{ discussList.landlord.comment }}
                  </span>
                </div>
                <div class="view-item">
                  <img
                    class="view-icon"
                    src="../assets/blog/view-icon.png"
                    alt=""
                  />
                  <span>{{ discussList.landlord.click }}</span>
                </div>
              </div>
            </div>
            <div class="division-line"></div>
            <div class="problem-content-modualr">
              <div v-html="discussList.landlord.detail"></div>
            </div>
            <div class="from-info-modualr">
              <div class="address-item">
                {{ $t("translateText.fromText")
                }}{{ discussList.landlord.from }}
              </div>
              <div class="date-item">
                {{
                  $t("translateText.firstfloor")
                }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                  changeTime(discussList.landlord.create_time)
                }}
              </div>
            </div>
          </div>
          <!-- </el-col>
          </el-row> -->
        </div>
        <div
          class="forum-detail-list-modualr"
          v-for="(item, index) in discussList.respondent"
          :key="index"
        >
          <el-row>
            <el-col :span="4" :xs="24">
              <div class="left-item-modualr">
                <img class="user-face" :src="item.head_img" alt="" />
                <div class="user-name">{{ item.write }}</div>
              </div>
            </el-col>
            <el-col :span="20" :xs="24">
              <div class="right-item-modualr">
                <div class="problem-content-modualr">
                  <div class="problem-content-item" v-html="item.comment"></div>
                </div>
                <div class="from-info-modualr">
                  <div class="address-item">
                    {{ $t("translateText.fromText") }}{{ item.from }}
                  </div>
                  <div class="date-item">
                    {{ index + 2
                    }}{{
                      $t("translateText.floorText")
                    }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ changeTime(item.create_time ) }}
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="forum-Management-release-modualr">
      <div class="release-header">
        {{ $t("translateText.postreplyText") }}
      </div>
      <div class="release-problem-modular" style="height: 180px;">
        <!-- <el-input type="textarea" :rows="4" :placeholder="$t('translateText.placeholdercontentsText')" v-model="problemTextArea">
        </el-input> -->
        <quill-editor
        style="height:140px;"
          ref="myQuillEditor"
          v-model="problemTextArea"
          :options="editorOption"
        />
      </div>
      <el-button class="release-btn" @click="forumReply()">{{
        $t("translateText.publishText")
      }}</el-button>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      editorOption: {
        // Some Quill options...
        modules: {
          //工具栏定义的
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }],
            ["link", "image"],
            ["blockquote", "code-block"],
            [{ size: ["small", false, "large", "huge"] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
          ],
        },
      },
      currLanguage: localStorage.getItem("curLanguageType"), //当前语言
      menuBar: [
        { title: "首页", eng_title: "Home" },
        { title: "论坛", eng_title: "Forum" },
        { title: "讨论", eng_title: "Discuss" },
      ],
      blog_id: "",
      problemTextArea: "",
      discussList: {
        landlord: {},
        respondent: [
          // {
          //   name: "张天爱",
          //   face: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202106%2F13%2F20210613235426_7a793.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1677552376&t=db5c65c7d87a436cb5d3f14f9f2a6469',
          //   content: '良好的回流焊点、外观应该符合以下几点：1、焊点表面应该完整而平滑光亮，不能凹凸不平;2、焊料与焊盘表面的润视角以300以下为好，不超过600；3、元件的高度要适中，焊料要完全覆盖焊盘与引线焊接的部位。',
          //   address: '浙江',
          //   date: '2022-11-11 11:48'
          // },
          // {
          //   name: "张天爱",
          //   face: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202106%2F13%2F20210613235426_7a793.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1677552376&t=db5c65c7d87a436cb5d3f14f9f2a6469',
          //   content: '良好的回流焊点、外观应该符合以下几点：1、焊点表面应该完整而平滑光亮，不能凹凸不平;2、焊料与焊盘表面的润视角以300以下为好，不超过600；3、元件的高度要适中，焊料要完全覆盖焊盘与引线焊接的部位。',
          //   address: '北京',
          //   date: '2022-11-11 11:48'
          // },
        ],
      },
    };
  },
  methods: {
    /**
     * 论坛详情
     */
    forumDetail() {
      let that = this;
      let data = {
        blog_id: that.blog_id,
      };
      this.$http.forumDetail(
        data,
        (res) => {
          if (res.ret == 1) {
            // 发布者
            that.discussList.landlord = res.forumDetail;
            // 其余人评论
            that.discussList.respondent = res.comment;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 回复
     */
    forumReply() {
      let that = this;
      let data = {
        blog_id: that.blog_id,
        comment: that.problemTextArea,
        pid: 0,
      };
      this.$http.reply(
        data,
        (res) => {
          if (res.ret == 1) {
            // this.$message.success(res.msg);
            this.$message.warning("发布成功，待审核");
            that.problemTextArea = ""; //清空
            // 论坛详情
            that.forumDetail();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 跳转个人中心
     */
    toPersonCenter(index) {
      if (index == 0) {
        this.$router.push({
          path: "/",
        });
      } else {
        this.$router.push({
          path: "/forumManagement",
        });
      }
    },
  },
  mounted() {
    let that = this;

    // 页面路由参数
    that.blog_id = that.$route.query.uuid;
    // 论坛详情
    that.forumDetail();
    // that.menuBar[2].title = that.$route.query.title;
  },
};
</script>


// WEBPACK FOOTER //
// src/view/forumDetail.vue